export enum voucherReducerActionTypes {
  UPDATE_IS_OPEN = 'VOUCHER_UPDATE_IS_OPEN',
  UPDATE_CODE = 'VOUCHER_UPDATE_CODE',
}

interface VoucherUpdateIsOpenAction {
  type: voucherReducerActionTypes.UPDATE_IS_OPEN;
  payload: boolean;
}

interface VoucherUpdateCodeAction {
  type: voucherReducerActionTypes.UPDATE_CODE;
  payload: string;
}

export type VoucherReducerAction = VoucherUpdateIsOpenAction | VoucherUpdateCodeAction;

export interface VoucherReducerState {
  isOpen: boolean;
  code: string;
}

export const voucherReducerInitialState: VoucherReducerState = {
  isOpen: false,
  code: '',
};

const voucherReducer = (
  state: VoucherReducerState,
  action: VoucherReducerAction
): VoucherReducerState => {
  switch (action.type) {
    case voucherReducerActionTypes.UPDATE_IS_OPEN: {
      return {
        ...state,
        isOpen: action.payload,
        code: '',
      };
    }
    case voucherReducerActionTypes.UPDATE_CODE: {
      return {
        ...state,
        code: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default voucherReducer;
